// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3GBqt","disabled":"FileBtn_disabled__2EweG","warn":"FileBtn_warn__yCU8r","fade":"FileBtn_fade__29Pcg"};